/**
 * CS API request/response/error types.
 *
 * Contract mirrors the `zep-crm` backend endpoint
 *   POST {baseUrl}/api/public/cs/tickets
 * Treat shapes here as the source of truth for the HelpCenterWidget and
 * update both sides together.
 */

export interface SubmitTicketRequest {
  name: string;
  email: string;
  subject: string;
  message: string;
  service?: string;
  form_id?: string;
  workflow_id?: string;
  workflow_path?: string[];
  organization?: string;
  phone?: string;
  fields?: Record<
    string,
    string | number | boolean | Array<string | number | boolean>
  >;
  submitted_context?: Record<
    string,
    string | number | boolean | Array<string | number | boolean>
  >;
  client_context?: ClientContext;
  attachments?: CsTicketAttachment[];
  /** Honeypot — always the empty string for legitimate submissions. */
  website: string;
}

export interface CsTicketAttachment {
  name: string;
  url: string;
  key: string;
  size: number;
  content_type: string;
}

export interface UploadTicketAssetResponse extends CsTicketAttachment {}

export interface ClientContext {
  page_url?: string;
  referrer?: string;
  user_agent?: string;
  language?: string;
  timezone?: string;
  screen?: string;
  viewport?: string;
  platform?: string;
  connection_type?: string;
  hardware_concurrency?: number;
  device_memory?: number;
  touch_enabled?: boolean;
}

export interface SubmitTicketResponse {
  ticket_id: string;
}

export type CsSubmitErrorKind =
  | 'validation' // 422
  | 'rate_limited' // 429
  | 'upstream' // 502
  | 'server' // 500
  | 'network' // fetch threw
  | 'aborted' // AbortSignal fired
  | 'unknown';

export class CsSubmitError extends Error {
  readonly status: number;
  readonly kind: CsSubmitErrorKind;
  readonly body: unknown;

  constructor(
    message: string,
    opts: { status: number; kind: CsSubmitErrorKind; body?: unknown },
  ) {
    super(message);
    this.name = 'CsSubmitError';
    this.status = opts.status;
    this.kind = opts.kind;
    this.body = opts.body;
  }
}
